import { createApiClient } from '@titularis/api-client';

const baseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3333';

export const api = createApiClient({ baseUrl });
